'use client';

import type { PropsWithChildren } from 'react';
import { useExperimentExposure, type UseExperimentExposureArgs } from './use-experiment-exposure';

export type ExperimentExposureProviderProps = PropsWithChildren<UseExperimentExposureArgs>;

/**
 * Generic, source-agnostic composition wrapper around {@link useExperimentExposure}.
 *
 * Fires a single Amplitude `$exposure` event while rendering children unchanged.
 * Accepts flag/variant via props — the caller (typically a feature-specific
 * server component provider) is responsible for resolving experiment data from
 * whatever source it lives in (aggregation experiments map, Prismic, etc.).
 *
 * Client components that already run on the client can call the hook directly.
 */
export const ExperimentExposureProvider = ({ children, ...props }: ExperimentExposureProviderProps) => {
    useExperimentExposure(props);
    return <>{children}</>;
};
